module.exports = __webpack_public_path__ + "img/f_07.4821a2c.png";